export { default as ArrowSmDownIcon } from './ArrowSmDownIcon';
